import { useNavigate } from 'react-router-dom';
import { useCreatorMe } from '../../../lib/auth';
import styles from './Hub.module.css';

const VIDEO_STATUS_CFG: Record<string, { label: string; cls: string }> = {
  awaiting_submission: { label: 'Awaiting Submission', cls: styles.badgeGray },
  under_review: { label: 'Under Review', cls: styles.badgeBlue },
  revisions_requested: { label: 'Revisions Requested', cls: styles.badgeOrange },
  approved: { label: 'Approved', cls: styles.badgeGreen },
};

export function HomeView() {
  const nav = useNavigate();
  const { data } = useCreatorMe();
  if (!data) return null;
  const name = (data.submission?.fullName || data.email || '').split(' ')[0];
  const signed = data.all_documents_signed === true;
  const subStatus = data.submission?.status || 'ready_for_contract';

  const documentsBadge = signed ? (
    <span className={`${styles.badge} ${styles.badgeGreen}`}>Signed</span>
  ) : subStatus === 'pending_signature' || subStatus === 'ready_for_contract' ? (
    <span className={`${styles.badge} ${styles.badgeOrange}`}>Action required</span>
  ) : (
    <span className={`${styles.badge} ${styles.badgeGray}`}>Pending</span>
  );
  const codeBadge = signed ? (
    <span className={`${styles.badge} ${styles.badgeGreen}`}>Available</span>
  ) : (
    <span className={`${styles.badge} ${styles.badgeGray}`}>Locked</span>
  );
  const videoCfg =
    VIDEO_STATUS_CFG[data.video_status] ?? VIDEO_STATUS_CFG.awaiting_submission;
  const paymentBadge =
    data.payment_status === 'paid' ? (
      <span className={`${styles.badge} ${styles.badgeGreen}`}>Paid</span>
    ) : data.payment_status === 'processing' ? (
      <span className={`${styles.badge} ${styles.badgeBlue}`}>Processing</span>
    ) : (
      <span className={`${styles.badge} ${styles.badgeGray}`}>Pending</span>
    );

  const cards: { title: string; desc: string; to: string; badge?: React.ReactNode }[] = [
    { title: 'Profile', desc: 'Your contact info, platforms, and content details.', to: 'profile' },
    {
      title: 'Documents',
      desc: 'Review and sign your partnership documents.',
      to: 'documents',
      badge: documentsBadge,
    },
    {
      title: 'Medical Intake',
      desc: 'Complete your Kick Health intake to receive your product.',
      to: 'medical',
      badge: codeBadge,
    },
    {
      title: 'Brand Guidelines',
      desc: "Dos and don'ts for creating your Kick Health content.",
      to: 'guidelines',
    },
    {
      title: 'Video Submission',
      desc: 'Upload your content and track its review status.',
      to: 'video',
      badge: <span className={`${styles.badge} ${videoCfg.cls}`}>{videoCfg.label}</span>,
    },
    {
      title: 'Payment',
      desc: 'View your payment status and amount for this partnership.',
      to: 'payment',
      badge: paymentBadge,
    },
  ];

  return (
    <>
      <div className={styles.homeGreeting}>
        <div className={styles.homeHi}>Hi, {name}.</div>
        <div className={styles.homeSub}>
          Here's everything you need for your Kick Health partnership.
        </div>
      </div>
      <div className={styles.homeGrid}>
        {cards.map((c) => (
          <button
            key={c.to}
            type="button"
            className={styles.homeCard}
            onClick={() => nav(`/creator/${c.to}`)}
          >
            <div className={styles.homeCardIcon}>→</div>
            <div className={styles.homeCardTitle}>{c.title}</div>
            <div className={styles.homeCardDesc}>{c.desc}</div>
            <div className={styles.homeCardFooter}>
              {c.badge ?? <span />}
              <span className={styles.homeCardArrow}>→</span>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
